
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import GroupCusView from "../components/groupCustomerView";
import Footer from "../components/footer";

function GroupCusViewPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      < GroupCusView /> 
    <Footer />
    </div>
  </div>
  // <Login/>
  );
}
export default GroupCusViewPage;
